export default __webpack_public_path__ + "static/media/6.fea7b1c9.jpg";